import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {ReleveIndividuel} from '../../../models/rt2012/ReleveIndividuel';
import {Deserialize} from 'cerialize';
import {environment} from '../../../../environments/environment';
import {ActiveConsumptionPeriod} from '../../../models/rt2012/activeConsumptionPeriod';
import {Logement} from '../../../models/logement';
import {EnergieEnum} from '../../../pages/rt2012/suivi-des-consommations/enums/EnergieEnum';

@Injectable({
  providedIn: 'root'
})
export class ActiveConsumptionPeriodService {
  baseApiUrl: string = environment.api.baseUrl;

  constructor(private http: HttpClient) {

  }


  delete(period: ActiveConsumptionPeriod, logement: Logement, energy: EnergieEnum): Promise<any> {
    let url;
    if (EnergieEnum.CHAUFFAGE === energy) {
      url = `${this.baseApiUrl}rt2012/periode-marche-chauffage/${logement.id}/${period.id}`;
    } else {
      url = `${this.baseApiUrl}rt2012/periode-marche-refroidissement/${logement.id}/${period.id}`;
    }
    return this.http.delete(url).toPromise().then(
      (data) => {
        return data;
      },
      (data) => {
        if (data.status === 400) {
          return data.error;
        }
        throw new Error('An unexpected error occurred while data loading : ' + data);
      });
  }

  create(period: ActiveConsumptionPeriod, logement: Logement, energy: EnergieEnum): Promise<ReleveIndividuel> {
    let url;
    if (period.id) {
      if (EnergieEnum.CHAUFFAGE === energy) {
        url = `${this.baseApiUrl}rt2012/periode-marche-chauffage/${logement.id}/${period.id}`;
      } else {
        url = `${this.baseApiUrl}rt2012/periode-marche-refroidissement/${logement.id}/${period.id}`;
      }
    } else {
      url = `${this.baseApiUrl}rt2012/periode-marche/${energy}/${logement.id}`;
    }
    return this.http.post(url, period).toPromise().then(
      (rawReleve) => {
        return Deserialize(rawReleve, ReleveIndividuel);
      }, (data) => {
        if (data.status === 400 || data.status === 422) {
          return data.error;
        }
        throw new Error(`An unexpected error occurred while data loading ${JSON.stringify(data)}`);
      });
  }
}
